import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';
import SimpleCheckbox from '../simpleCheckbox';
import config from '../../../config';
import WorkDayConflictIconWithTooltip from './workDayConflictIconWithTooltip';

const WorkdayInput = (props) => {
  const dayName = moment().isoWeekday(props.input.value).format(config.fullDayOfWeek);

  return (
    <div className="o-flexbox__item">
      <SimpleCheckbox
        key={props}
        label={dayName}
        id={props.enabledName}
        name={props.enabledName}
        disabled={props.disabled}
        containerClass="c-checkbox u-mr--"
      />
      <WorkDayConflictIconWithTooltip
        dayConflicts={props.dayConflicts}
        display-if={props.dayHasConflicts}
      />
    </div>
  );
};

WorkdayInput.propTypes = {
  dayConflicts: PropTypes.arrayOf(PropTypes.shape({})),
  dayHasConflicts: PropTypes.bool,
  disabled: PropTypes.bool,
  enabledName: PropTypes.bool.isRequired,
  input: PropTypes.shape({
    value: PropTypes.bool.isRequired,
  }).isRequired,
};

WorkdayInput.defaultProps = {
  dayConflicts: [],
  dayHasConflicts: false,
  disabled: false,
};

export default WorkdayInput;
